<template>
  <div>
    <popup-hint hint="square">
      <template v-slot:breadcrumbs>
        <breadcrumbs home="Square"/>
      </template>
      <template v-slot:top>
        The Square app will process all fulfilled Square orders as Shipments in PURTRAK,
        automatically keeping your inventory current.
      </template>
    </popup-hint>

    <v-card flat>
      <div v-if="init" class="text-center mt-16">
        <v-progress-circular indeterminate/>
      </div>

      <v-tabs :vertical="!$vuetify.breakpoint.mobile" show-arrows v-else>

        <template v-if="permissions.includes('config.write')">
          <v-tab>Connection</v-tab>
          <v-tab-item>
            <apps-square-connection :square="square" @disconnect="square=null"/>
          </v-tab-item>
        </template>

        <template v-if="permissions.includes('inventory.write')">
          <v-tab :disabled="!square">Products</v-tab>
          <v-tab-item v-if="square">
            <apps-square-products :square="square"/>
          </v-tab-item>
        </template>

        <template v-if="permissions.includes('inventory.write')">
          <v-tab :disabled="!square">Inventory</v-tab>
          <v-tab-item v-if="square">
            <apps-square-inventory :square="square" @saveSettings="saveSettings"/>
          </v-tab-item>
        </template>

        <template v-if="permissions.includes('selling.write')">
          <v-tab :disabled="!square">Orders</v-tab>
          <v-tab-item v-if="square">
            <apps-square-orders :square="square" @saveSettings="saveSettings"/>
          </v-tab-item>
        </template>

        <template v-if="permissions.includes('selling')">
          <v-tab @click="$refs.log.load();clearAlerts()">
            <v-badge color="red" dot :value="showAlert">
              Log
            </v-badge>
          </v-tab>
          <v-tab-item eager>
            <apps-square-log ref="log"/>
          </v-tab-item>
        </template>
      </v-tabs>
    </v-card>
  </div>
</template>

<script>
import AppsSquareConnection from '@/views/apps/square/AppsSquareConnection'
import AppsSquareProducts from '@/views/apps/square/AppsSquareProducts'
import AppsSquareInventory from '@/views/apps/square/AppsSquareInventory'
import AppsSquareOrders from '@/views/apps/square/AppsSquareOrders'
import AppsSquareLog from '@/views/apps/square/AppsSquareLog'

export default {
  name: 'AppsSquare',
  components: {AppsSquareConnection ,AppsSquareProducts,
               AppsSquareInventory,AppsSquareOrders,AppsSquareLog},
  props: {
    alert: {type:Boolean, required:false, default:false}
  },
  data() {
    return {
      showAlert: this.alert,
      init: true,
      square: null
    }
  },
  computed: {
    permissions() {
      return this.$store.getters.company.permissions;
    },
  },
  async mounted() {
    if (this.$route.query.state) {
      // Must re-load company!
      if (localStorage.getItem('oauthCompanyId')) {
        this.$store.commit('setCompanyId', localStorage.getItem('oauthCompanyId'));

        const results = await this.$apiCall(`mutation AppsSquare($state:String!, $query: String!) {
                                                squareAuthorize(state:$state, query:$query) {
                                                  settings {
                                                    inventoryUpdateFrequency,orderProcessingFrequency,createDraftOrders,createDraftOrdersOnLowInventory,customerForOrders,
                                                    qbo,invoice,paymentMethodId,qboAccountRef,inBond
                                                    tipItemId
                                                  }
                                                  locations {id,name}
                                                  locationMap{siteId,siteName,locationId}
                                                  products {id,productName,variants {id,variantName,sku}}
                                                }
                                              }`,
                                            {state:localStorage.getItem('oauthState'),
                                             query:new URL(location.href).search.substring(1)},
                                             false, 'square');
        if (!results.error) {
          this.square = results.data.squareAuthorize;
          // Set up initial default location mappings
          for (const location of this.square.locationMap) {
            const results2 = await this.$apiCall(`mutation AppsSquare($input: SquareLocationMappingInput!) {
                                                    squareSetLocation(input:$input) {locationId}
                                                  }`,
                                              {input:{siteId:location.siteId,locationId:this.square.locations[0].id}}, false, 'square');
            if (!results2.error)
              location.locationId = this.square.locations[0].id;
          }
        }
      }
      else if (!error)
        this.$store.commit('setError', {message:'Distillery not found', type:'error'})
      this.$router.replace({query: {}});
    }

    else {
      const results = await this.$apiCall(`query AppsSquare {
                                              square {
                                                settings {
                                                  inventoryUpdateFrequency,orderProcessingFrequency,createDraftOrders,
                                                  createDraftOrdersOnLowInventory,customerForOrders,qbo,invoice,paymentMethodId,qboAccountRef,inBond
                                                  tipItemId
                                                }
                                                locations {id,name}
                                                locationMap{siteId,siteName,locationId}
                                                products {id,productName,variants {id,variantName,sku}}
                                              }
                                            }`,
                                          {accounting:this.connectedToAccounting}, false, 'square');
      if (!results.error) {
        this.square = results.data.square;
      }
    }

    localStorage.removeItem('oauthCompanyId');
    localStorage.removeItem('oauthState');
    this.init = false;
  },
  methods: {
    async saveSettings() {
      const results = await this.$apiCall(`mutation AppsSquare($input:SquareSettingsInput!) {
                                                squareUpdateSettings(input:$input) {settings {
                                                  inventoryUpdateFrequency,orderProcessingFrequency,createDraftOrders,createDraftOrdersOnLowInventory,customerForOrders,
                                                  qbo,invoice,paymentMethodId,inBond
                                                  tipItemId
                                                }}
                                              }`,
                                          {input:this.square.settings}, false, 'square');
      if (!results.error)
        Object.assign(this.square.settings, results.data.squareUpdateSettings.settings);
    },
    async clearAlerts() {
      if (!this.alert)
        return;

      await this.$apiCall(`mutation AppsSquare {setAlertForAddOn(name:"Square",on:false)}`, {});
      await this.$store.dispatch('checkTasks', true);
      this.showAlert = false;
    }
  }
}
</script>